export { default } from './NavNeededIndicator';
